module.exports = __webpack_public_path__ + "img/template-1-desktop.74e69ffc.png";